import Vue from 'vue'

// 创建事件总线
const EventBus = new Vue()

export default EventBus
